import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取页面设置标签信息
    GET_PAGE_LABEL(data) {
        controller='Pagelabel';
        action='getPageLabel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    //获取页面设置标签信息(用于编辑、修改标签)
    GET_PAGE_LABEL_INFO(data) {
        controller='Pagelabel';
        action='getPageLabelInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    //获取单个设置的数据值
    SET_PAGE_LABEL(data) {
        controller='Pagelabel';
        action='savePageLabel';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


}